module.exports = "module.exports = __webpack_public_path__ + \"static/media/footer.44eeece0.template\";"